module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wood_a32708.jpg";